import { render, staticRenderFns } from "./FormRacisForm.vue?vue&type=template&id=3fa8e835&scoped=true"
import script from "./FormRacisForm.vue?vue&type=script&lang=js"
export * from "./FormRacisForm.vue?vue&type=script&lang=js"
import style0 from "./FormRacisForm.vue?vue&type=style&index=0&id=3fa8e835&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa8e835",
  null
  
)

export default component.exports